import requester from 'utils/requester';
import api from 'config/api';
import { IRequesterResponse, CategoryType, DetailsObjectType } from './loader-types';

type VodPageParams = { extId: CategoryType['ext_id']; offset?: number };

const allowedVODCategories = ['movies', 'tvseries', 'cartoons'];
const loadTabContent = async (extId: CategoryType['ext_id'], offset: number) => {
  const $offset = Number.isInteger(offset) ? offset : 0;

  const { data: content } = (await requester({
    method: 'get',
    url: `${api.host}${api.endpoints.assets}`,
    params: {
      'categories.ext_id[in]': extId,
      $expand: 'resources(url),entitlement,favorite,bookmark',
      $orderby: '-year',
      $limit: 12,
      $offset,
    },
  })) as IRequesterResponse<DetailsObjectType[]>;

  return { content, offset: $offset };
};

export const vodPageLoader = async ({ extId, offset }: VodPageParams) => {
  // tab content
  if (extId) {
    return await loadTabContent(extId, offset);
  }

  const name = 'Video';

  const { data } = (await requester({
    method: 'get',
    url: `${api.host}${api.endpoints.bootstrap}`,
    params: {
      $expand: 'categories',
    },
  })) as IRequesterResponse<{ categories: CategoryType[] }>;

  const tabs = data.categories.filter((cat) => allowedVODCategories.includes(cat.ext_id));

  tabs.sort((a, b) => a.order - b.order);

  return { name, tabs };
};

export default vodPageLoader;
